function getOrdinal(n) {
    let suffix = 'th';
    if (n % 100 < 11 || n % 100 > 13) {
        switch (n % 10) {
        case 1: suffix = 'st'; break;
        case 2: suffix = 'nd'; break;
        case 3: suffix = 'rd'; break;
        }
    }
    return n + suffix;
}

document.addEventListener('DOMContentLoaded', () => {
    window.dataLayer = window.dataLayer || [];
    let allPromotions = [];

    // Push view_promotions event with all visible promos on the page
    (function() {
        const allContainers = Array.from(document.querySelectorAll('.dl-container'));
        const promotionName = document.getElementById('promo-name')?.dataset.promoName || window.location.pathname.split('/').pop();

        // Only include visible containers
        const visibleContainers = allContainers.filter(container => {
            const computedStyle = window.getComputedStyle(container);
            return computedStyle.display !== 'none';
        });

        let promoIndex = 0;
        const promotions = [];
        
        visibleContainers.forEach((container) => {
            const promotionCreative = container.getAttribute('data-promotion-id');
            const firstChild = container.firstElementChild;
            const hasGridCellInnerClass = Array.from(firstChild.classList).some(className => 
                className.startsWith('xy-grid-container')
            );
            
            if (hasGridCellInnerClass) {
                // Handle grid containers - treat each cell as its own banner
                const gridCells = firstChild.querySelectorAll('.xy-grid-cell');
                gridCells.forEach((cell, cellIndex) => {
                    promoIndex++;
                    const cellImg = cell.querySelector('img');
                    const cellImgSrc = cellImg ? cellImg.src : "https://cdn.shopify.com/s/files/1/2170/8465/files/placeholder.jpg?v=1759779720";
                    const cellLinkText = cell?.dataset?.promotionId || null;

                    promotions.push({
                        'promotionName': `${promotionName} ${getOrdinal(promoIndex)} Banner`,
                        'promotionCreativeName': cellLinkText || promotionCreative,
                        'promotionId': cellImgSrc,
                        'promotionIndex': promoIndex,
                        'promotionPosition': promotionName,
                        'promotionType': 'gtm_banner',
                    });
                });
            } else {
                // Handle regular containers
                promoIndex++;
                const img = container.querySelector('img');
                const imgSrc = img ? img.src : "https://cdn.shopify.com/s/files/1/2170/8465/files/placeholder.jpg?v=1759779720";
                const position = promoIndex;
                if (container.querySelector('slideshow-component-v2')) {
                let slideshow = container.querySelector('slideshow-component-v2');
                    slideshow.DlInfo = {
                        'promotionName': `${promotionName} ${getOrdinal(position)} Banner`,
                        'promotionId': imgSrc,
                        'promotionCreativeName': promotionCreative,
                        'promotionIndex': position,
                        'promotionPosition': promotionName,
                        'promotionType': 'gtm_banner'
                    };
                }
                promotions.push({
                    'promotionName': `${promotionName} ${getOrdinal(position)} Banner`,
                    'promotionCreativeName': promotionCreative,
                    'promotionId': imgSrc,
                    'promotionIndex': position,
                    'promotionPosition': promotionName,
                    'promotionType': 'gtm_banner'
                });
            }
        });

        if (promotions.length > 0) {
            window.dataLayer.push({
                'event': 'view_promotion',
                'promotions': promotions,
                '_clear': true
            });
            allPromotions = promotions;
        }
    })();

    // Listen for clicks on links or buttons inside .dl-container
    document.querySelectorAll('.dl-container').forEach(container => {
        container.addEventListener('click', function(event) {

            const ignoreTags = ['FS-PRODUCT-WIDGET', 'SLIDESHOW-COMPONENT-V2', 'FIT-FINDER-LANDING-PAGE-COMPONENT'];
            const ignoreClasses = ['banner-multi-cta', 'xy-it-list-content-section', 'xy-it-list-content', 'xy-it-list-main-text', 'xy-it-list-block'];
            if (ignoreTags.includes(event.target.tagName) || ignoreClasses.some(className => event.target.classList.contains(className))) {
                return;
            }

            const clickableTarget = event.target.closest('a[href], button, .multi-cta-button, .banner-button, .xy-button');

            if (!clickableTarget) {
            return;
            }

            let buttonText = '';
            let parentContainer = clickableTarget.closest('.dl-container') || container;
            let parentA = clickableTarget.closest('a');

            //filter out false positives where container is non-linking and items contain links
            if (event.target.classList.contains('custom-banner-background') && !parentA) {return;}

            if (!parentContainer) {
            return;
            }

            if (
                clickableTarget.classList.contains('multi-cta-button') ||
                clickableTarget.classList.contains('banner-button') ||
                clickableTarget.classList.contains('xy-button')
            ) {
                buttonText =
                    clickableTarget.dataset.linkTitle ||
                    clickableTarget.dataset.promotionId ||
                    clickableTarget.textContent.trim();
            } else if (
                parentA &&
                (parentA.classList.contains('multi-cta-button') || parentA.classList.contains('xy-button'))
            ) {
                buttonText =
                    parentA.dataset.linkTitle ||
                    parentA.dataset.promotionId ||
                    parentA.textContent.trim();
            } else if (
                clickableTarget.classList.contains('xy-section-container-link') ||
                parentContainer.querySelectorAll('.multi-fallback-link').length > 0 ||
                parentContainer.querySelectorAll('.custom-banner-link').length > 0
            ) {
                buttonText = '';
            }

            const promotions = allPromotions.filter(promotion => promotion.promotionCreativeName.toLowerCase() === parentContainer.dataset.promotionId.toLowerCase());

            if (promotions.length > 0) {
                if (buttonText !== '') {
                    promotions[0] = {...promotions[0], promotionButton: buttonText};
                }

                window.dataLayer.push({
                    'event': 'select_promotion',
                    'promotions': promotions[0],
                    '_clear': true
                });
            }

        });
    });
});
